import type { PayerDirectoryFieldValues } from './PayerDirectoryFields';

export const DEFAULT_PAYER_DIRECTORY_FIELD_VALUES: PayerDirectoryFieldValues = {
  name: '',
  aliases: '',
  stateEntity: '',
  payerType: 'commercial',
  providerLine: '',
  verificationStrategy: 'voice',
  status: 'pending',
};
